import script from "./MoleculeModalGoalsGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoleculeModalGoalsGroup.vue?vue&type=script&setup=true&lang=ts"

import "./MoleculeModalGoalsGroup.vue?vue&type=style&index=0&id=2ce9222e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce9222e"]])

export default __exports__